import { Reveal } from "@components/ui";
import certLogo1 from "@assets/images/843d0c8b86dbc768979704a55b63f14c-1@2x.png";
import certLogo2 from "@assets/images/843d0c8b86dbc768979704a55b63f14c-11@2x.png";
import certLogo3 from "@assets/images/843d0c8b86dbc768979704a55b63f14c-12@2x.png";
import certLogo4 from "@assets/images/843d0c8b86dbc768979704a55b63f14c-13@2x.png";
import certLogo5 from "@assets/images/843d0c8b86dbc768979704a55b63f14c-14@2x.png";

const companyDetails = [
  { label: "Affiliation", value: "Member of Contra Group of Companies" },
  {
    label: "Trade License No.",
    value: "910109 — Dubai Economic Department",
  },
  {
    label: "Head Office",
    value:
      "Office No. 8, Unimark Business Center, Royal House, Hor Al Anz East, Dubai, UAE",
  },
  { label: "Email", value: "help@gasis.ae" },
  { label: "WhatsApp Support", value: "+971 56 503 6420" },
  {
    label: "Emergency Hotline",
    value: "800-GASIS (42747)",
    accent: true,
  },
];

const certLogos = [certLogo1, certLogo2, certLogo3, certLogo4, certLogo5];

export function AboutCompanyOverviewSection() {
  return (
    <section className="w-full py-14 md:py-16 lg:py-20 px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-10 md:gap-12">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <Reveal direction="up" className="lg:w-[45%] shrink-0">
            <div className="flex flex-col gap-4">
              <span className="text-[13px] md:text-[14px] font-semibold tracking-[0.1em] uppercase text-[#f24d2b]">
                About GASIS
              </span>
              <h2 className="text-[24px] md:text-[32px] lg:text-[40px] font-semibold tracking-[-0.04em] text-[#090d2c] leading-[1.25]">
                A UAE licensed engineering & utility management company.
              </h2>
              <p className="text-[15px] md:text-[17px] tracking-[-0.02em] text-[#62636c] leading-[1.7]">
                Combining local expertise, certified safety standards, and cutting-edge
                technology to deliver reliable, transparent, and sustainable energy solutions.
              </p>
            </div>
          </Reveal>

          <Reveal direction="up" delay={60} className="flex-1">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
              {companyDetails.map((item, i) => (
                <div
                  key={i}
                  className="flex flex-col gap-0.5 py-3 border-b border-[#e9e8e6] last:border-b-0 sm:[&:nth-last-child(-n+2)]:border-b-0"
                >
                  <span className="text-[12px] md:text-[13px] tracking-[0.04em] uppercase text-[#62636c]/60 font-medium">
                    {item.label}
                  </span>
                  <span
                    className={`text-[16px] md:text-[18px] font-semibold tracking-[-0.02em] break-words ${
                      item.accent ? "text-[#f24d2b]" : "text-[#090d2c]"
                    }`}
                  >
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal direction="up">
          <div className="flex flex-col sm:flex-row items-center gap-5 sm:gap-6 py-6 border-t border-[#e9e8e6]">
            <p className="text-[13px] md:text-[14px] tracking-[-0.02em] text-[#62636c]/60 font-medium shrink-0 whitespace-nowrap">
              Licensed & Certified
            </p>
            <div className="flex items-center flex-wrap gap-4 md:gap-6">
              {certLogos.map((logo, i) => (
                <img
                  key={i}
                  src={logo}
                  alt="Certification"
                  className="w-[60px] md:w-[80px] h-auto object-contain opacity-40 hover:opacity-80 transition-opacity duration-300"
                />
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
